
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ClientData } from "@/models";
import {
    Flex,
    Box,
} from "@chakra-ui/react";
import { useClient } from "@/hooks";
import { showToast } from "@/utils/toast";
import { ClientFormDrawer } from "@/layouts";
import styles from "./styles.module.scss";
import { DrawerList } from "barte-design-system";
interface ClientSelectorProps {
    name: string;
    label?: string;
    labelColor?: string;
    optional?: boolean;
    initialClient?: any;
    placeholder?: string;
    idClient?: boolean;
    clients: Array<ClientData>;
    selectedClient: ClientData;
    setClients: React.Dispatch<React.SetStateAction<Array<ClientData>>>;
    setSelectedClient: React.Dispatch<React.SetStateAction<ClientData>>;
}

export function InputSearch({
    name,
    label,
    setClients,
    optional = false,
    clients,
    labelColor,
    selectedClient,
    setSelectedClient,
    initialClient,
    placeholder,
    idClient = false,
}: ClientSelectorProps) {
    const [isClientDrawerOpen, setIsClientDrawerOpen] = useState(false);
    const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
    const [filteredClients, setFilteredClients] = useState([]);
    const [hasNewClient, setHasNewClient] = useState<boolean>(false)
    const { getClients } = useClient();
    let timeoutId: NodeJS.Timeout | null = null;
    useEffect(() => {
        if (!clients) return;
        setFilteredClients(clients);
    }, [clients]);

    function handleDropDownToggleState() {
        setTimeout(() => {
            setIsClientDropdownOpen(!isClientDropdownOpen);
        }, 200);
    }

    function selectClient(client: ClientData) {
        setSelectedClient(client);
        setIsClientDropdownOpen(false);
    }

    function setActiveClient(data: Array<ClientData>) {
        if (idClient) {
            setSelectedClient(
                data?.filter((item) => item.id === initialClient)[0]
            );
            return
        }
        setSelectedClient(
            data?.filter((item) => item.document === initialClient.document)[0]
        );
    }


    async function handleGetClient(client?: any) {
        try {
            const { data } = await getClients(
                {},
                {
                    size: 100,
                    page: 0,
                    sort: "name,ASC",
                }
            );
            setClients(data?.content);
            selectClient(client);
            if (initialClient) return setActiveClient(data?.content);
        } catch (error) {
            showToast({
                type: "error",
                message: "Não foi possível deletar o cliente.",
            });
        }
    }

    async function handleGetClientSearch(client?: any) {
        try {
            const { data } = await getClients(
                {
                    name: client ? client : "",
                },
                {
                    size: 100,
                    page: 0,
                    sort: "name,ASC",
                }
            );
            setClients(data?.content);
            selectClient(client);
            setIsClientDropdownOpen(true);

            if (initialClient) return setActiveClient(data?.content);
        } catch (error) {
            showToast({
                type: "error",
                message: "Não foi possível deletar o cliente.",
            });
        }
    }


    function handleSearchBox(e: string) {
        handleGetClientSearch(e)
        if (!selectedClient?.name) {
            setSelectedClient({} as ClientData);
        }


    }

    function selectClientWithMaxId() {
        const maxIdObject = clients.reduce((maxObj, obj) => {
            if (obj.id > maxObj.id) {
                return obj;
            } else {
                return maxObj;
            }
        });
        setSelectedClient(maxIdObject);
    }
    useEffect(() => {
        handleGetClient()
    }, []);

    useEffect(() => {
        if (hasNewClient === true) {
            handleGetClient()
        }
    }, [hasNewClient]);

    useEffect(() => {
        if (hasNewClient === true) {
            selectClientWithMaxId();
            setHasNewClient(false)
        }
    }, [clients]);


    return (
        <>
            {isClientDrawerOpen && createPortal(
                <ClientFormDrawer
                    isOpen={isClientDrawerOpen}
                    onClose={() => setIsClientDrawerOpen(false)}
                    onSuccess={() => {
                        setIsClientDrawerOpen(false);
                        setHasNewClient(true);
                    }}
                />,
                document.body
            )}
            <div className={styles.container}>
                {label && <span style={{ color: labelColor ? labelColor : "#000000" }}>{`${label} ${optional ? "(Opcional)" : ""}`}</span>}

                <Flex 
                    position="relative"
                    w="100%"
                >
                    <input
                        className={`${styles.clientInput}`}
                        onBlurCapture={handleDropDownToggleState}
                        onFocusCapture={handleDropDownToggleState}
                        placeholder={placeholder}

                        value={selectedClient?.name}
                        autoComplete="off"
                        disabled={!!initialClient}
                        onChange={(e) => {
                            handleSearchBox(e.target.value),
                                setSelectedClient({
                                    ...selectedClient,
                                    name: e.target.value,
                                });
                        }}
                        style={{ paddingLeft: (selectedClient?.name === undefined || selectedClient?.name === "") ? '40px' : "16px"}}
                    />
                    {isClientDropdownOpen && (
                        <Box position="absolute" top="100%" right="0" zIndex={100} w="100%">
                            <DrawerList
                                items={[
                                    {
                                        label: "Adicionar cliente",
                                        onClick: () => setIsClientDrawerOpen(true),
                                    },
                                    ...filteredClients?.map(client => ({
                                        key: client.id,
                                        label: client.name,
                                        onClick: () => selectClient(client),
                                    })),
                                ]}
                            />
                        </Box>
                    )}
                </Flex>
                        
                
            </div>
        </>
    )
}